<template lang="pug">
.google-map(:id="mapName")
</template>

<script>
import _ from 'lodash';

export default {
  name: 'google-map',
  computed: {
    latLon() {
      if (_.isEmpty(this.location.address.lat_lng)) return null;
      return new google.maps.LatLng(
        this.location.address.lat_lng[0],
        this.location.address.lat_lng[1],
      );
    },
    mapName() {
      return `${this.name}-map`;
    },
  },
  data() {
    return {
      data: null,
      marker: null,
    };
  },
  methods: {
    addMarker() {
      this.marker = new google.maps.Marker({
        position: this.latLon,
        map: this.map,
        title: this.location.label,
      });
    },
    refreshMap() {
      this.addMarker();
      if (this.map !== null) {
        this.map.setCenter(this.latLon);
      }
    },
  },
  mounted() {
    if (window.google !== undefined && this.latLon !== null) {
      this.map = new google.maps.Map(document.getElementById(this.mapName), {
        zoom: 13,
        center: this.latLon,
      });
      this.addMarker();
    }
  },
  props: {
    name: {
      type: String,
    },
    location: {
      type: Object,
    },
    refresh: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    refresh(val) {
      if (val) this.refreshMap();
    },
  },
};
</script>

<style lang="scss" scoped>
.google-map {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/GoogleMap.vue